import LearningProductParent from '../purchase/learning-product-parent.vue';
import Purchase from '@/app/modules/account/components/purchase/purchase.vue';

export default {
  name: 'account-purchases',
  components: {
    Purchase,
    LearningProductParent,
  },
  computed: {
    parentProducts() {
      const prods = this.$store.getters['billing/getPurchases'];
      // filter only parents from the products returned by stripe
      const parentProducts = prods.filter(prod => prod.metadata && prod.metadata.is_parent === 'true');
      // order the products
      return parentProducts.sort((a, b) => a.metadata.order - b.metadata.order);
    },
  },
};
